// First-party, privacy-friendly page-view tracking (no third-party cookies).
const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;

function uuid() {
  return typeof crypto !== "undefined" && crypto.randomUUID
    ? crypto.randomUUID()
    : `${Date.now()}-${Math.random().toString(16).slice(2)}`;
}

// With consent: a persistent ID (enables unique & returning-visitor metrics).
// Without consent: a session-scoped ID that is cleared when the tab closes,
// so traffic is still counted anonymously with no cross-session tracking.
function getVisitorId() {
  if (localStorage.getItem("bh_consent") === "granted") {
    let id = localStorage.getItem("bh_vid");
    if (!id) {
      id = uuid();
      localStorage.setItem("bh_vid", id);
    }
    return id;
  }
  let id = sessionStorage.getItem("bh_vid_s");
  if (!id) {
    id = uuid();
    sessionStorage.setItem("bh_vid_s", id);
  }
  return id;
}

export function trackPageView(path) {
  try {
    const body = JSON.stringify({
      visitor_id: getVisitorId(),
      path: path || window.location.pathname,
      referrer: document.referrer || "",
      utm_source: new URLSearchParams(window.location.search).get("utm_source") || "",
    });
    const url = `${BACKEND_URL}/api/analytics/track`;
    if (navigator.sendBeacon) {
      navigator.sendBeacon(url, new Blob([body], { type: "application/json" }));
    } else {
      fetch(url, {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body,
        keepalive: true,
      });
    }
  } catch (e) {
    /* analytics must never break the app */
  }
}
